import React, { CSSProperties } from 'react';
import { Stack } from 'react-bootstrap';
import { BsClock } from 'react-icons/bs';
import { ReactComponent as ChefHat } from '../../../../../assets/icons/chef-hat.svg';
import { Course } from '../../../../../types/course.type';
import { Order } from '../../../../../types/orders.type';
import { DateCell } from '../../../../../components/tables/cellComponents/DateCell';
import { displaySessionTimeRange } from '../../../../../utils/dateUtils';

export const StylePink: React.CSSProperties = {
  fill: `#BA1F69`
};

export const StyleOrange: React.CSSProperties = {
  fill: `#d36a48`
};

export const StyleGreen: React.CSSProperties = {
  fill: `#B4C634`
};

export const course_type_style_lookup = (key: string) => {
  switch (key) {
    case 'after_school':
      return StylePink;
    case 'camp':
      return StyleOrange;
    case 'event':
      return StyleGreen;
    default:
      return { fill: 'black' };
  }
};

export const CourseCount: React.FC<{ count: number; style?: CSSProperties }> = ({
  count,
  style
}) => {
  return (
    <Stack
      direction="horizontal"
      gap={1}
      className="text-info"
    >
      <ChefHat style={style ?? { fill: 'currentColor', marginLeft: '2px', marginRight: '1px' }} />
      {count}
      <span>Classes</span>
    </Stack>
  );
};

interface CourseTimesProps {
  course: Course;
  dayOfWeek?: string;
}

export const CourseTimes: React.FC<CourseTimesProps> = ({ course, dayOfWeek }) => {
  const tz = (course.venue as any)?.location?.timezone;
  const timeDisplay = displaySessionTimeRange(course.starts_at, course.ends_at, tz);

  return (
    <Stack
      direction="horizontal"
      gap={1}
    >
      <BsClock />
      {dayOfWeek && <span className="fw-light ff-inter">{dayOfWeek}</span>}
      <span>{timeDisplay}</span>
    </Stack>
  );
};

interface CourseDateTimesProps {
  order: Order;
}
export const OrderCourseCount: React.FC<CourseDateTimesProps> = ({ order }) => {
  const { course, lesson_count } = order;
  const style = {
    transform: 'translateY(-2px)',
    ...course_type_style_lookup(course.course_type)
  };
  return (
    <CourseCount
      count={lesson_count ?? course.lessons?.length ?? 0}
      style={style}
    />
  );
};

export const OrderCourseDates: React.FC<CourseDateTimesProps> = ({ order }) => {
  const { course } = order;
  return (
    <span className="text-truncate">
      <DateCell date={course.starts_on} format="MM/dd/yyyy" />
      {' - '}
      <DateCell date={course.ends_on} format="MM/dd/yyyy" />
    </span>
  );
};

export const OrderCourseTimes: React.FC<CourseDateTimesProps> = ({ order }) => {
  return (
    <CourseTimes
      course={order.course}
      dayOfWeek={order.course.day_of_week}
    />
  );
};

export const OrderCourseDatesTimesCount: React.FC<CourseDateTimesProps> = ({ order }) => {
  return (
    <Stack direction="horizontal">
      <OrderCourseDates order={order} />
      <OrderCourseTimes order={order} />
      <OrderCourseCount order={order} />
    </Stack>
  );
};
